
import './Components.css';
import packageJson from '../../package.json';
import {Cross2Icon} from './../icons/Icons';
import { convertAppVersionToReadable } from '../utils/Utilities';
import { ThemeContext } from '../contexts/AppContext';
import { useContext } from 'react';

function Options({drawerOpenState, showDetailedSummary, onDetailedSummaryChange}){

    //showDetailedSummary:Boolean;
    //onDetailedSummaryChange?: (checked: boolean) => void;
    //const [showDetailedSummary, setDetailedSummary ] = useState(false);
    //const [showDetailedSummary, onDetailedSummaryChange] = useState(false);
    const { theme, setAppTheme } = useContext(ThemeContext);



    function aboutClick(){
        window.alert("Web Version: " + convertAppVersionToReadable(packageJson.version) + "\nBuild type: " + packageJson.buildType);
    }

    function toggleTheme(){
        setAppTheme(theme === 'dark' ? 'light' : 'dark');
    }
    const handleChange = (e) => {   
        onDetailedSummaryChange(e.target.checked);
      }

  


    return(
        <div className='settings-container'>
            {drawerOpenState && (
                <button style={{width:'40px', height:'40px', marginLeft:'auto', background:'transparent', border:'0px'}} onClick={drawerOpenState(false)}>
                    <Cross2Icon width='40px' height='40px'/>
                </button>
            )}
            
            <h2>OPTIONS</h2>
            <div style={{display: 'flex', alignItems: 'center'}}>
                        <input type="checkbox" id='detailedSummaryCheckbox' style={{width:'25px', height:'25px'}} onChange={handleChange} checked={showDetailedSummary} />
                        <label htmlFor='detailedSummaryCheckbox' style={{marginLeft:'5px'}}>Shots in Summary View</label>
            </div>
            <div style={{width:'calc(100% - 60px)', height:'20px'}}/>
            <button className='button' style={{marginBottom:"10px", width:'calc(100% - 60px)'}} onClick={toggleTheme}>{theme === 'light' ? 'Turn on Dark Mode' : 'Turn on Light Mode'}</button>
            <button className='button' style={{marginBottom:"10px", width:'calc(100% - 60px)'}} onClick={() => aboutClick()}>About</button>
            
        </div>
    );
}

export default Options;